<template>
  <div class="firs-day-of-week-block">
    <v-layout pa-2 mt-2>
      <v-flex>
        <v-card>
          <v-card-title>
            <i class="material-icons light-blue--text">chat</i>
            <div class="headline">&nbsp;Global notifications:</div>
          </v-card-title>
          <v-card-text class="list-group">
            <template v-if="globalNotifications.length">
              <div class="list-group-item" v-for="(item, index) in globalNotifications" :key="index">
                <v-layout row wrap>
                  <v-flex xs9>
                    {{item.message}}
                  </v-flex>
                  <v-flex xs3>
                    Expire in: {{Number(item.expires_in_seconds / 60).toFixed(1)}} min
                  </v-flex>
                </v-layout>
              </div>
            </template>
            <div v-else class="list-group-item text-xs-center">
              No active global notifications
            </div>
          </v-card-text>
          <v-layout row wrap >
            <v-flex xs12 sm12 md12 lg8 pa-2 mb-2 >
              <v-btn color="primary" class="submit"
                @click="dialog = true"
                :loading="loading"
                :disabled="loading"
              >Add Global Notification</v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="dialog" persistent max-width="600">
      <v-card>
        <v-card-title>
          <span class="headline mr-4">
            <v-icon class="pl-2">add_circle_outline</v-icon>
            Add Global Notification
          </span>
          <v-btn absolute left depressed flat fab small @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="add_notification" data-vv-scope="add_notification" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12>
                <v-textarea
                  v-model="form.message"
                  label="Message*"
                  rows="3"
                  v-validate="'required'"
                  data-vv-name="add_notification.message"
                  :error-messages="errors.collect('add_notification.message')"
                  required
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model.number="form.expires_in_minutes"
                  type="number"
                  label="Expire in*"
                  v-validate="'required|integer'"
                  data-vv-name="add_notification.expires_in_minutes"
                  :error-messages="errors.collect('add_notification.expires_in_minutes')"
                  suffix="min"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
          <v-btn color="primary" flat @click="addNotification()" :loading="loading" :disabled="loading">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'GlobalNotifications',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      dialog: false,
      loading: false,
      form: {
        expires_in_minutes: 5,
        message: 'Sorry we applying some changes and fixes. Please save your unsaved changes. Service will be available in 3-5 minutes.'
      },
      globalNotifications: [],
      dictionary: {
        en: {
          custom: {
            'add_notification.message': {
              required: 'Message required'
            },
            'add_notification.expires_in_minutes': {
              required: 'Required expirу in',
              integer: 'Numbers only'
            }
          }
        }
      }
    }
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')
    this.getNotifications()
  },
  methods: {
    getNotifications () {
      this.loading = true
      this.$store.dispatch('NOTIFICATIONS').then(res => {
        this.globalNotifications = res.global_notifications
        this.loading = false
      }, err => {
        this.loading = false
        console.log('NOTIFICATIONS error', err)
        let errorText = this.$services.getApiError(err)
        if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
      })
    },
    addNotification () {
      this.$validator.validateAll('add_notification').then(res => {
        if (res) {
          this.loading = true
          let params = {
            expires_in_seconds: parseInt(this.form.expires_in_minutes) * 60,
            message: this.form.message
          }
          this.$store.dispatch('ADD_GLOBAL_NOTIFICATION', params).then(res => {
            this.closeModal()
            this.getNotifications()
            this.loading = false
          }, err => {
            this.loading = false
            console.log('ADD_GLOBAL_NOTIFICATION error', err)
            let errorText = this.$services.getApiError(err)
            if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
          })
        }
      })
    },
    closeModal () {
      this.dialog = false
      this.form = {
        expires_in_minutes: 5,
        message: ''
      }
      this.$validator.errors.clear('add_notification')
    }
  }
}
</script>

<style scoped>
.list-group-item {
    cursor: move;
    position: relative;
    display: block;
    padding: .75rem 1.25rem;
    margin-bottom: -1px;
    background-color: #fff;
    border: 1px solid rgba(0,0,0,.125);
}
.list-group-item:first-child {
    border-top-left-radius: .25rem;
    border-top-right-radius: .25rem;
}
.list-group-item .flex {
  margin: auto;
}
.list-group {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-direction: column;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    margin-bottom: 0;
    min-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/users/GlobalNotifications.vue